import type { ConnectionTier as ConnectionTierValue } from '@pages/discipline/classroom'

type ForcedSide = 'self' | 'peer' | 'both'

const PRODUCTION_ENVIRONMENTS = ['production', 'prod']

const MS_PER_SECOND = 1000

const loadClassroom = () => import('@pages/discipline/classroom')

export default defineNuxtPlugin(() => {
  const { environment } = useRuntimeConfig().public

  if (PRODUCTION_ENVIRONMENTS.includes(environment)) return

  Object.assign(globalThis, {
    lkRoom: async () => (await loadClassroom()).refRoom.value,

    lkSimulateBandwidth: async (bitsPerSecond: number) => {
      const { refRoom } = await loadClassroom()

      return refRoom.value?.simulateScenario('subscriber-bandwidth', bitsPerSecond)
    },

    lkForceTier: async (tier: string | null, side: ForcedSide = 'both'): Promise<string> => {
      const { setForcedTier } = await loadClassroom()

      if (tier === null) {
        setForcedTier(null, side)

        return `released ${side}; tiers follow real measurements again`
      }

      const { ConnectionTier } = await loadClassroom()
      const tiers = Object.values(ConnectionTier)
      const requested = tier.toUpperCase() as ConnectionTierValue

      if (!tiers.includes(requested)) return `unknown tier ${tier}; expected one of ${tiers.join(', ')}`

      setForcedTier(requested, side)

      const { CONNECTION_SAMPLE_INTERVAL_MS } = await loadClassroom()

      return `forcing ${requested} on ${side} from the next sample, within ~${CONNECTION_SAMPLE_INTERVAL_MS / MS_PER_SECOND}s`
    },
  })
})
